import { createContext, useContext } from 'react';
import { Master } from './api/graphql/master/types';

export const masterDataContext = createContext<Master | null>(null);

export const useMasterContext = () => {
  const ctx = useContext(masterDataContext);
  if (!ctx) {
    throw new Error('MasterContext not provided');
  }
  return ctx;
};
